export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_03.6d2e0682.jpg";